import React from "react";
import Footer from "../../common/Footer/Footer";
import UserPage from "../../common/UserPage/UserPage";
import SurveySettings from "../../components/AdminSettings/SurveySettings";

const AdminSurveysHome = () => {
  return (
    <div className="min-h-screen flex flex-col">
      <UserPage />
      <div className="flex-1 flex flex-col">
        <SurveySettings />
      </div>
      <Footer />
    </div>
  );
};

export default AdminSurveysHome;
